import { useState } from 'react';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SpinnerBlock from 'components/others/SpinnerBlock';
import OffOperationInfo from '../OffOperationInfo';
import ProposalShortageBlock from '../ProposalShortage';
import ProductsTableBody from './ProductsTableBody/ProductsTableBody';
import AddProductsDropdown from './ProductsTableBody/AddProductsDropdown';

const ObjectTabProducts = () => {
    const { t } = useTranslation(['Objects']);
    const [showSpinnerProducts, setShowSpinnerProducts] = useState(false);
    const [showOperationInfo, setShowOperationInfo] = useState(false);

    return (
        <>
            <OffOperationInfo
                show={showOperationInfo}
                setShow={setShowOperationInfo}
            />

            <div>
                <ProposalShortageBlock kind="products" />

                {showSpinnerProducts && <SpinnerBlock onlyBlur={true} show={true} />}
                <div className="crm-table-wrap">
                    <Table className="ProductObjectTable table-hover table">
                        <thead>
                            <tr className="bg-light">
                                <td className="head-prodname">{t('productFields.name')}</td>
                                <td className="head-price">{t('productFields.price')}</td>
                                <td className="head-count">{t('productFields.count')}</td>
                                <td className="head-amount">{t('productFields.amount')}</td>
                                <td className="head-warehouse">{t('productFields.warehouse')}</td>
                                <td className="head-actions">{t('productFields.actions')}</td>
                            </tr>
                        </thead>
                        <ProductsTableBody
                            showOperationInfo={showOperationInfo}
                            setShowOperationInfo={setShowOperationInfo}
                            setShowSpinnerProducts={setShowSpinnerProducts}
                        />
                    </Table>
                </div>

                <AddProductsDropdown />
            </div>
        </>
    );
};

export default ObjectTabProducts;
